import md5 from 'crypto-js/md5';
import { userIdVar } from './localVariables';

export const generateUniqueRequestId = ():string => md5(`${userIdVar()}-${new Date().getTime()}`).toString();
